// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2dc11897","453":"6deb98ca","732":"141dd94b","977":"9f82c427"}[chunkId] + ".chunk.js";
};